// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoCard_wrapper__8n-pd"};